import { arrayMove } from '@dnd-kit/sortable'
import { FieldsType } from '@systemeio/digital-store-shared'
import { ContactSlugEnum, FieldErrorAndDescription, getContactFieldTitle } from '@systemeio/ui'
import StoreAddField from 'modules/stores/store/components/contact-fields/components/store-add-field'
import StoreField from 'modules/stores/store/components/contact-fields/components/store-field'
import { useStoreContactFields } from 'modules/stores/store/hooks/use-store-contact-fields'
import React, { FC } from 'react'
import { Loader } from 'shared/components/loader'
import Sortable from 'shared/components/sortable'

export interface InitFieldsInterface {
  slug: ContactSlugEnum
  required: boolean
  mandatory: boolean
}

interface StoreFieldsProps {
  fields: FieldsType[]
  onChange: (fields: FieldsType[]) => void
  initFields?: InitFieldsInterface[]
  error?: string
}

const StoreFields: FC<StoreFieldsProps> = ({ fields, onChange, error, initFields }) => {
  const { availableFields, isReady } = useStoreContactFields({
    initFields,
    onChange,
    savedFields: fields,
  })

  const getField = (field: FieldsType) => (
    <StoreField
      slug={field.slug}
      key={field.slug}
      label={getContactFieldTitle(field)}
      isRequired={field.required}
      onChangeRequired={value =>
        onChange(fields.map(f => (f.slug === field.slug ? { ...f, required: value } : f)))
      }
      onDelete={slug => onChange(fields.filter(f => f.slug !== slug))}
      initFields={initFields}
    />
  )

  const onMoveItem = async (_: number, activeIndex: number, overIndex: number) =>
    onChange(arrayMove(fields, activeIndex, overIndex))

  return (
    <>
      {!isReady ? (
        <Loader className={'self-center'} />
      ) : (
        <>
          <Sortable
            draggable={getField}
            items={fields.map(field => ({
              ...field,
              id: field.slug,
            }))}
            onMove={onMoveItem}
          >
            {fields.map(getField)}
          </Sortable>
          <FieldErrorAndDescription error={error} />
          <StoreAddField fields={availableFields} onAdd={data => onChange(fields.concat(data))} />
        </>
      )}
    </>
  )
}

export default StoreFields
